import { useEffect, useState } from 'react';
import { apiClient } from '../services/api';
import type { BuiltInUser } from '../types';
import { formatDateTime } from '../utils/dateFormat';

export function BuiltInUsersPage() {
  const [users, setUsers] = useState<BuiltInUser[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiClient
      .getBuiltInUsers()
      .then((data) => setUsers(data))
      .catch(() =>
        setError('Could not load built-in users. Verify GET /api/system/built-in-users exists in backend.'),
      );
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-semibold">System Users</h1>
      <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">Built-in system and automation accounts.</p>
      {error ? <p className="mt-3 text-sm text-amber-600">{error}</p> : null}
      <div className="mt-4 overflow-x-auto card">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-gray-200 dark:border-gray-700">
              <th className="p-2">Name</th>
              <th className="p-2">Email</th>
              <th className="p-2">Type</th>
              <th className="p-2">Roles</th>
              <th className="p-2">Last Active</th>
              <th className="p-2">Created</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id} className="border-b border-gray-100 dark:border-gray-800">
                <td className="p-2">{user.fullName}</td>
                <td className="p-2">{user.email}</td>
                <td className="p-2">{user.userType ?? 'System'}</td>
                <td className="p-2">{user.roles?.join(', ') || '—'}</td>
                <td className="p-2">{formatDateTime(user.lastActiveAt)}</td>
                <td className="p-2">{formatDateTime(user.createdAt)}</td>
              </tr>
            ))}
            {users.length === 0 ? (
              <tr>
                <td colSpan={6} className="p-3 text-gray-500">
                  No built-in users found.
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
}
